import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

export const adminOnlyGuard = (): boolean | UrlTree => {
  const router = inject(Router);
  const toasterService = inject(ToastrService);
  const auth = JSON.parse(localStorage.getItem('user') || '{}');
  if (auth?.type === 'ADMIN') {
    return true;
  }
  toasterService.error(
    $localize`Vous n'avez pas la permission d'accéder à cette ressource`
  );
  return router.createUrlTree(['/dashboard']);
};
